var exports = {
  "Sl": "xaf9ae18d--19bcb0--image",
  "VN": "xaf9ae18d--19bcb0--close",
  "Qs": "xaf9ae18d--19bcb0--content",
  "pq": "xaf9ae18d--19bcb0--info",
  "wm": "xaf9ae18d--19bcb0--logo",
  "Cv": "xaf9ae18d--19bcb0--copyright",
};

module.exports = exports;
